if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;

        if (this.variantIdInput) this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.submitButton = this.querySelector('[type="submit"]');
        if (this.submitButton) {
          this.submitButtonText = this.submitButton.querySelector('span');
        }
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.submitButton) return;
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        
        // Also handle sticky button loading state
        const stickyBtn = document.getElementById(`StickyATC-${this.dataset.sectionId}`);
        if (stickyBtn) {
          stickyBtn.classList.add('satc-loading');
          const stickyBtnText = stickyBtn.querySelector('.sticky-btn-top');
          if (stickyBtnText) stickyBtnText.innerHTML = '<div class="satc-spinner"></div> Ekleniyor...';
        }

        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.headers['Accept'] = 'application/json';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        // Masaüstünde cart drawer kullanma — sections parametresi gönderme
        const isDesktop = window.innerWidth >= 990;
        const cartDrawer = !isDesktop ? (document.querySelector('cart-drawer') || document.querySelector('cart-notification')) : null;

        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            cartDrawer.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          cartDrawer.setActiveElement && cartDrawer.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText && this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            this.error = false;

            if (isDesktop) {
              // Masaüstü: drawer tetiklemeden direkt sepet sayfasına git
              window.location = routes.cart_url;
              return;
            }

            // Mobil: PubSub eventi yayınla ve drawer aç
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });

            // Mobil: drawer aç
            if (!cartDrawer) {
              window.location = routes.cart_url;
              return;
            }

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) quickAddModal.hide(true);

            cartDrawer.renderContents(response);
          })
          .catch((e) => {
            console.error('[product-form] add to cart error:', e);
            if (isDesktop) {
              window.location.href = routes.cart_url;
            }
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        
        // Reset sticky button
        const stickyBtn = document.getElementById(`StickyATC-${this.dataset.sectionId}`);
        if (stickyBtn) {
          stickyBtn.classList.remove('satc-loading');
          const stickyBtnText = stickyBtn.querySelector('.sticky-btn-top');
          if (stickyBtnText) stickyBtnText.innerHTML = 'Sepete Ekle';
        }

        const spinnerEl = this.querySelector('.loading__spinner');
        if (spinnerEl) spinnerEl.classList.add('hidden');
      });
      }

      toggleSubmitButton(disable = true, text, modifyClass = true) {
        if (!this.submitButton) return;
        this.submitButton.toggleAttribute('disabled', disable);
        if (disable) {
          this.submitButton.setAttribute('aria-disabled', true);
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('aria-disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }

        if (!modifyClass) return;

        if (disable) {
          this.submitButton.classList.add('disabled');
        } else {
          this.submitButton.classList.remove('disabled');
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) this.errorMessage.textContent = errorMessage;
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
